<div class="flex flex-col gap-2 md:gap-4 w-full px-2 pb-2">
    <!-- Header -->
    <div class="flex items-center gap-3">
        <span class="typography-title-m font-medium">
            {{ 'natural_stone.tutorial_title' | translate }}
        </span>
        <span class="bg-semantic-info text-white typography-body-s-regular px-2 py-0.5 rounded-full">
            {{ 'new' | translate | lowercase }}
        </span>
    </div>
    <div class="border-b border-divider-divider" ></div>

    <!-- Content -->
    <div class="flex flex-col md:flex-row gap-6">
        <div class="md:w-1/2 flex-shrink-0">
            <video
                [src]="currentStepData.video"
                class="w-full h-full object-cover"
                muted
                controls
                loop
                autoplay
            ></video>
        </div>
        <div class="flex flex-col gap-3">
            <span class="typography-body-m-light">
                {{ 'natural_stone.tutorial_step' | translate: { varStep: currentStep, varTotal: totalSteps } }}
            </span>
            <h2 class="typography-title-l m-0">
                {{ currentStepData.titleKey | translate }}
            </h2>
            <p class="typography-body-l-regular m-0">
                {{ currentStepData.descriptionKey | translate }}
            </p>
        </div>
    </div>

    <div class="border-b border-divider-divider"></div>

    <!-- Footer -->
    <div class="flex justify-between items-center">
        <app-button *ngIf="currentStep > 1" [ghost]="true" [showIcon]="true" [iconPosition]="'start'" size="medium" (onClick)="back()">
            {{ 'global.back' | translate }}
        </app-button>
        <div class="flex-1"></div>
        <app-button [primary]="true" [showIcon]="!isLastStep()" size="medium" (onClick)="next()">
            {{ (isLastStep() ? 'natural_stone.go_to_the_catalog' : 'global.continue') | translate }}
        </app-button>
    </div>
</div>
